<template>
  <div id="fkfs">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'fkfs'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/guide/fkfs/Fkfs.vue